import React from 'react';



class Navbar extends React.Component {
    render() {
        return (
            
            <React.Fragment>

                <head>
                    <link href="https://fonts.googleapis.com/css?family=Roboto+Condensed:700&display=swap" rel="stylesheet" />
                    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.13.0/css/all.css" integrity="sha384-Bfad6CLCknfcloXFOyFnlgtENryhrpZCe29RTifKEixXQZ38WheV+i/6YWSzkz3V" crossorigin="anonymous" />
                </head>

            <body>
                <header>
                    <section class="headerContainer">
                        <img src="/assets/ZHLOGO_200x200.png" class="heroLogo" alt="zen home logo" />
                        <nav class="navbar">

                            <ul class="navbar-list">
                                <li><a href="index.html">HOME</a></li>
                                <li><a href="products.html">SHOP</a></li>
                                <li><a href="contact.html">CONTACT </a></li>

                            </ul>
                        </nav>
                        <div class="nav-icons">
                        <i class="far fa-lg fa-user-circle"></i> |
                        <i class="fas fa-lg fa-search"></i> |
                        <i class="fas fa-lg fa-shopping-bag"></i>
                        </div>
                    </section>
                </header>
                </body>

            </React.Fragment>
        )

        }

    }

    export default Navbar;